import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { CountdownCard } from '../components/CountdownCard';
import { SnackpassStyle } from '../components/SnackpassStyle';
import { Questionnaire } from '../components/Questionnaire';
export default function Index() {
  return <div className="w-full relative bg-[#f5f5f5] overflow-x-hidden font-sans" data-id="element-194">
      <Navbar data-id="element-195" />

      {/* Hero Section (Full viewport height) */}
      <div className="relative w-full min-h-screen flex flex-col items-center justify-center pt-20 pb-16" data-id="element-196">
        {/* Background Marquee */}
        <div className="absolute top-1/2 left-0 -translate-y-1/2 w-full pointer-events-none select-none z-0 overflow-hidden opacity-60" data-id="element-197">
          <div className="animate-marquee whitespace-nowrap flex" data-id="element-198">
            {Array.from({
            length: 8
          }).map((_, i) => <span key={i} className="text-[18vw] font-black text-[#e5e5e5] tracking-tighter leading-none mx-8" data-id="element-199">
                COMING SOON
              </span>)}
          </div>
        </div>

        <div className="relative z-10 w-full flex flex-col items-center justify-center px-4" data-id="element-200">
          <Hero data-id="element-201" />
          <CountdownCard data-id="element-202" />
        </div>

        {/* Join now button at bottom of hero */}
        <div className="relative z-10 mt-20" data-id="element-203">
          <button onClick={() => {
          const el = document.getElementById('questionnaire-section');
          if (el) el.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="bg-[#1c1c1e] text-white px-8 py-3.5 rounded-xl font-semibold text-base hover:bg-black transition-colors shadow-lg inline-flex items-center gap-2" data-id="element-204">
            Join now
          </button>
        </div>
      </div>

      {/* Content Sections */}
      <SnackpassStyle data-id="element-205" />

      <div id="questionnaire-section" data-id="element-206">
        <Questionnaire data-id="element-207" />
      </div>
    </div>;
}